import { feedPageActionTypes } from "../Constants/ActionTypes";

const initialState = {
  posts: [],
  endTotalPost: false,
  videoSharing: {
    isOpen: false,
    isCoachAthleteListPopupOpen: false,
    coaches: [],
    athletes: [],
    selectedVideo: null,
  },
};

export const FeedPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case feedPageActionTypes.END_TOTAL_POST:
      return {
        ...state,
        endTotalPost: payload,
      };

    case feedPageActionTypes.SET_ALL_POST_LIST:
      return {
        ...state,
        posts: payload,
      };

    case feedPageActionTypes.LIKE_DISLIKE_POST:
      return {
        ...state,
        posts: state?.posts?.map((post) => {
          if (post?.shareMediaId === payload?.postId) {
            return {
              ...post,
              isLikedFlag: payload?.status,
              likedCount: payload?.status
                ? post.likedCount + 1
                : post.likedCount - 1,
            };
          }
          return post;
        }),
      };

    case feedPageActionTypes.ADD_COMMENT:
      return {
        ...state,
        posts: state?.posts?.map((post) => {
          if (post?.shareMediaId === payload?.postId) {
            return {
              ...post,
              commentMediaDetailsList: [
                {
                  commentMessage: payload?.commentMessage,
                  name: payload?.userName,
                  createdAt: new Date(),
                },
                ...(post?.commentMediaDetailsList || []),
              ].map((comment) => {
                const commentTime = new Date(comment.createdAt);
                const currentTime = new Date();
                const seconds = Math.floor((currentTime - commentTime) / 1000);

                const minutes = Math.floor(seconds / 60);

                const hours = Math.floor(minutes / 60);

                const days = Math.floor(hours / 24);

                let finalString = "";
                if (days) {
                  finalString = `${days} day${days > 1 ? "s" : ""} Ago`;
                } else if (hours) {
                  finalString = `${hours} Hour${hours > 1 ? "s" : ""} Ago`;
                } else if (minutes) {
                  finalString = `${minutes} Minute${
                    minutes > 1 ? "s" : ""
                  } Ago`;
                } else {
                  finalString = `${seconds} second${
                    seconds > 1 ? "s" : ""
                  } Ago`;
                }

                return {
                  ...comment,
                  lastSeen: finalString,
                };
              }),
              commentCount: post?.commentCount + 1,
            };
          }
          return post;
        }),
      };

    case feedPageActionTypes.TOGGLE_ATHLETES_COACHES_LIST_POPUP:
      return {
        ...state,
        videoSharing: {
          ...state.videoSharing,
          isCoachAthleteListPopupOpen: payload,
        },
      };

    case feedPageActionTypes.TOGGLE_SHARE_VIDEO_POPUP:
      return {
        ...state,
        videoSharing: {
          ...state.videoSharing,
          isOpen: payload,
        },
      };

    case feedPageActionTypes.SELECT_DESELECT_COACHES:
      return {
        ...state,
        videoSharing: {
          ...state.videoSharing,
          coaches: payload,
        },
      };

    case feedPageActionTypes.SELECT_DISELECT_ATHLETES:
      return {
        ...state,
        videoSharing: {
          ...state.videoSharing,
          athletes: payload,
        },
      };

    case feedPageActionTypes.SELECT_VIDEO:
      return {
        ...state,
        videoSharing: {
          ...state.videoSharing,
          selectedVideo: payload,
        },
      };

    default:
      return state;
  }
};
